import { createSelector } from "@ngrx/store";
import { AuthSelector, JurisdictionSelector } from "@obg/ngx.core";
import { forEach } from "lodash-es";

import { filterByContentState, filterByJurisdictionState } from "../content/content.util";
import { CoreContentState } from "../state";

import { Quicklink } from "./quicklink.model";

/**
 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
 */
export namespace QuicklinkSelector {
	const getQuicklinks = (state: CoreContentState) => state.quicklink.quicklinks;

	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	export const getAll = createSelector(
		getQuicklinks,
		AuthSelector.isAuthenticated,
		JurisdictionSelector.get,
		(quicklinks, isAuthenticated, jurisdiction): Record<string, Quicklink[]> => {
			const quicklinksDictionary: Record<string, Quicklink[]> = {};
			forEach(quicklinks, (quicklink, name) => {
				quicklinksDictionary[name] = filterByJurisdictionState(
					filterByContentState(quicklink, isAuthenticated),
					jurisdiction
				);
			});
			return quicklinksDictionary;
		}
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	export const get = (name: string) =>
		createSelector(
			getQuicklinks,
			AuthSelector.isAuthenticated,
			JurisdictionSelector.get,
			(quicklinks, isAuthenticated, jurisdiction): Quicklink[] =>
				filterByJurisdictionState(filterByContentState(quicklinks[name], isAuthenticated), jurisdiction)
		);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric QuickLinkService from svc-content instead
	 */
	export const isBusy = (state: CoreContentState): boolean => state.quicklink.isBusy;
}
